import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconRestaurant = ({ className, height, width, fill }: IconInterface) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 48 48'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={fill || 'none'}
      d="M14.25 44V25.6q-2.6-.55-4.425-2.625Q8 20.9 8 18V4h3v14h3.25V4h3v14h3.25V4h3v14q0 2.9-1.825 4.975Q19.85 25.05 17.25 25.6V44ZM35 44V28h-5.75V12.75q0-3.95 2.4-6.35Q34.05 4 38 4v40Z"
    />
  </svg>
)

export default Icon(IconRestaurant)
